import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_CROATIAN_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Broj', 'Broj kartice'],
    cardExpiry: ['Istek', 'Datum isteka'],
};

export const TUI_CROATIAN_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Popularno',
        history: 'Nedavno',
        placeholder: 'Pretraži',
        hotkey: 'za pretraživanje',
        all: 'Sve',
        empty: 'Nema rezultata',
    },
};

export const TUI_CROATIAN_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Odustani',
    done: 'Gotovo',
    more: 'Više',
    otherDate: 'Drugi datum...',
    showAll: 'Prikaži sve',
    hide: 'Sakrij',
    mobileCalendarTexts: [
        'Odaberite dan',
        'Odaberite razdoblje',
        'Odaberite dane',
    ],
    range: ['Od', 'Do'],
    countTexts: ['Više', 'Manje'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'dan.mjesec.godina',
        MDY: 'mjesec.dan.godina',
        YMD: 'godina.mjesec.dan',
    },
    digitalInformationUnits: ['Bajt', 'Kilobajt', 'Megabajt'],
    passwordTexts: ['Prikaži lozinku', 'Sakrij lozinku'],
    copyTexts: ['Kopiraj', 'Kopirano'],
    shortCalendarMonths: [
        'Sij',
        'Velj',
        'Ožu',
        'Tra',
        'Svi',
        'Lip',
        'Srp',
        'Kol',
        'Ruj',
        'Lis',
        'Stu',
        'Pro',
    ],
    pagination: ['Prethodna stranica', 'Sljedeća stranica'],
    fileTexts: {
        loadingError: 'Greška pri učitavanju',
        preview: 'Pregled',
        remove: 'Ukloni',
    },
    inputFileTexts: {
        defaultLabelSingle: 'ili povuci ovdje',
        defaultLabelMultiple: 'ili povuci ovdje',
        defaultLinkSingle: 'Odaberi datoteku',
        defaultLinkMultiple: 'Odaberi datoteke',
        maxSizeRejectionReason: 'Datoteka je prevelika',
        formatRejectionReason: 'Nevažeći format datoteke',
        drop: 'Povuci datoteku ovdje',
        dropMultiple: 'Povuci datoteke ovdje',
    },
    multiSelectTexts: {
        all: 'Odaberi sve',
        none: 'Ne odaberi ništa',
    },
    confirm: {
        yes: 'Da',
        no: 'Ne',
    },
    previewTexts: {
        rotate: 'Rotiraj',
    },
    zoomTexts: {
        zoomOut: 'Umanji',
        zoomIn: 'Uvećaj',
        reset: 'Resetiraj',
    },
    phoneSearch: 'Pretraži zemlju ili kod',
};

export const TUI_CROATIAN_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Jednobojno', 'Gradijent boja'],
    toolbarTools: {
        undo: 'Poništi',
        redo: 'Ponovi',
        font: 'Font',
        fontStyle: 'Stil fonta',
        fontSize: 'Veličina fonta',
        bold: 'Podebljano',
        italic: 'Kurziv',
        underline: 'Podcrtano',
        strikeThrough: 'Precrtano',
        justify: 'Poravnaj',
        justifyLeft: 'Poravnaj lijevo',
        justifyCenter: 'Centriraj',
        justifyRight: 'Poravnaj desno',
        justifyFull: 'Poravnaj obostrano',
        list: 'Popis',
        indent: 'Povećaj uvlačenje',
        outdent: 'Smanji uvlačenje',
        unorderedList: 'Neuređeni popis',
        orderedList: 'Uređeni popis',
        quote: 'Citat',
        foreColor: 'Boja teksta',
        backColor: 'Boja pozadine',
        hiliteColor: 'Boja istaknutog',
        clear: 'Očisti',
        link: 'Poveznica',
        attach: 'Priloži datoteku',
        tex: 'Umetni TeX',
        code: 'Kod',
        image: 'Umetni sliku',
        insertHorizontalRule: 'Umetni vodoravnu liniju',
        superscript: 'Eksponent',
        subscript: 'Indeks',
        insertTable: 'Umetni tablicu',
        insertGroup: 'Umetni grupu',
        hiliteGroup: 'Istakni grupu',
        removeGroup: 'Ukloni grupu',
        insertAnchor: 'Umetni sidro',
        mergeCells: 'Spoji ćelije',
        splitCells: 'Podijeli ćelije',
        rowsColumnsManaging: 'Upravljanje redovima i stupcima',
        cellColor: 'Boja ćelije',
        setDetails: 'Postavi detalje',
        removeDetails: "Ukloni detalje",
    },
    editorEditLink: {
        urlExample: 'primjer.com',
        anchorExample: 'sidro',
    },
    editorTableCommands: [
        ['Umetni stupac prije', 'Umetni stupac poslije'],
        ['Umetni red prije', 'Umetni red poslije'],
        ['Ukloni stupac', 'Ukloni red'],
    ],
    editorCodeOptions: ['Kod u tekstu', 'Blok koda'],
    editorFontOptions: {
        small: 'Malo',
        large: 'Veliko',
        normal: 'Normalno',
        title: 'Naslov',
        subtitle: 'Podnaslov',
    },
};

export const TUI_CROATIAN_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Prikaži/Sakrij',
    paginationTexts: {
        pages: 'Stranice',
        linesPerPage: 'Redaka po stranici',
        of: 'od',
    },
};

export const TUI_CROATIAN_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Siječanj',
        'Veljača',
        'Ožujak',
        'Travanj',
        'Svibanj',
        'Lipanj',
        'Srpanj',
        'Kolovoz',
        'Rujan',
        'Listopad',
        'Studeni',
        'Prosinac',
    ],
    close: 'Zatvori',
    clear: 'Očisti',
    nothingFoundMessage: 'Nema rezultata',
    defaultErrorMessage: 'Nevažeća vrijednost',
    spinTexts: ['Prethodni', 'Sljedeći'],
    shortWeekDays: ['Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub', 'Ned'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_CROATIAN_LANGUAGE: TuiLanguage = {
    name: 'croatian',
    ...TUI_CROATIAN_LANGUAGE_CORE,
    ...TUI_CROATIAN_LANGUAGE_KIT,
    ...TUI_CROATIAN_LANGUAGE_ADDON_TABLE,
    ...TUI_CROATIAN_LANGUAGE_ADDON_COMMERCE,
    ...TUI_CROATIAN_LANGUAGE_ADDON_EDITOR,
    ...TUI_CROATIAN_LANGUAGE_LAYOUT,
};